import React from 'react';

export const GenericMessage = (props) => (
  <div className="server-down">
    <div>{props.message}</div>
  </div>
)
